import { EditorState, Modifier, SelectionState } from 'draft-js'
import { ANNOTATION_STYLE } from '.'
import { AnnotationData, AnnotationFormData } from './types'

export const createAnnotationAtSelection = (
  setEditorState,
  getEditorState,
  formData: AnnotationFormData
) => {
  const editorState = getEditorState()
  const selection = editorState.getSelection()

  const contentState = editorState.getCurrentContent()
  const contentStateWithEntity = contentState.createEntity(
    ANNOTATION_STYLE,
    'MUTABLE',
    {
      categoryId: formData.category?.value.categoryId,
      itemId: formData.item?.value.id,
      childId: formData.child?.value.id,
    } as AnnotationData
  )
  const entityKey = contentStateWithEntity.getLastCreatedEntityKey()
  const contentStateWithLink = Modifier.applyEntity(
    contentStateWithEntity,
    selection,
    entityKey
  )
  const newEditorState = EditorState.set(editorState, {
    currentContent: contentStateWithLink,
  })
  setEditorState(newEditorState)
  return newEditorState
}

const getCurrentEntityKey = (editorState) => {
  const selection = editorState.getSelection()
  const anchorKey = selection.getAnchorKey()
  const contentState = editorState.getCurrentContent()
  const anchorBlock = contentState.getBlockForKey(anchorKey)
  const offset = selection.anchorOffset
  const index = selection.isBackward ? offset - 1 : offset
  return anchorBlock.getEntityAt(index)
}

export const getCurrentEntity = (editorState) => {
  const contentState = editorState.getCurrentContent()
  const entityKey = getCurrentEntityKey(editorState)
  return entityKey ? contentState.getEntity(entityKey) : null
}

export const hasAnnotationsEntity = (editorState) => {
  const entity = getCurrentEntity(editorState)
  return entity && entity.getType() === ANNOTATION_STYLE
}

export const removeEntity = (editorState) => {
  const contentState = editorState.getCurrentContent()
  const selectionState = editorState.getSelection()
  const startKey = selectionState.getStartKey()
  const contentBlock = contentState.getBlockForKey(startKey)
  const startOffset = selectionState.getStartOffset()
  const entity = contentBlock.getEntityAt(startOffset)

  if (!entity) {
    return editorState
  }

  let entitySelection: any = null

  contentBlock.findEntityRanges(
    (character) => character.getEntity() === entity,
    (start, end) => {
      entitySelection = selectionState.merge({
        anchorOffset: start,
        focusOffset: end,
      })
    }
  )

  const newContentState = Modifier.applyEntity(
    contentState,
    entitySelection,
    null
  )

  const newEditorState = EditorState.push(
    editorState,
    newContentState,
    'apply-entity'
  )

  return newEditorState
}

export const forceAnnotationSelection = (
  setEditorState,
  getEditorState,
  editParams
) => {
  const editorState = getEditorState()
  const contentState = editorState.getCurrentContent()
  const selectionState = editorState.getSelection()
  const startKey = selectionState.getStartKey()
  const contentBlock = contentState.getBlockForKey(startKey)

  const text = contentBlock.getText()
  const startFrom =
    getEditorState().getSelection().getAnchorOffset() -
    editParams.decoratedText.length
  const startIndex = text.indexOf(editParams.decoratedText, startFrom)

  const annotationSelection = new SelectionState({
    anchorKey: startKey,
    anchorOffset: startIndex,
    focusKey: startKey,
    focusOffset: startIndex + editParams.decoratedText.length,
  })

  setEditorState(
    EditorState.forceSelection(getEditorState(), annotationSelection)
  )
}

export const createSelectOptions = (array, labelField: string) => {
  return array.map((item) => ({
    value: item,
    label: item[labelField],
  }))
}
